import { Box, Button, Chip, IconButton, Tooltip } from "@mui/material";
import Datatable from "../../../components/features/Datatable";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { BackNavIcon, DeleteIconButton, EditIconButton } from "../../../../assets/common-svg/CommonSvg";
import { useNavigate } from "react-router";
import DeleteModal from "../../../components/common/BaseModal/DeleteModal";
import {
  allProcessListsById,
  deleteFaQ,
  listingByProcessId,
  selectedModule,
  selectedProcess,
  viewDetailFaq,
} from "../../../slices/help";
import UpdateHelpSequence from "./updateHelpSequence";
import { notify } from "../../../utils/methods/notification";

const ViewProcessingAccordian = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page] = useState(1);
  const [maxPages, setMaxPages] = useState(null);
  const [total, setTotal] = useState(null);
  const module = useSelector(selectedModule);
  const process = useSelector(selectedProcess);
  const processes = useSelector(allProcessListsById);
  const [rowID, setRowID] = useState(null);
  const [open, setOpen] = useState(false);
  const [updateSequence, setUpdateSequence] = useState(false);
  const data = { items: processes };
  const [selectProcess, setSelectProcess] = useState([]);

  const updateFilter = (dataTableParams) => {
    const fullParams = {
      ...dataTableParams,
      id: process.id,
      status: -1,
    };

    fetchUsers({ params: fullParams });
  };

  const fetchUsers = async (filter) => {
    try {
      const response = await dispatch(listingByProcessId(filter)).unwrap();
      setTotal(response.data.total_count);
      setSelectProcess(response.data.data.items); // initial load, not append
      if (response) {
        setMaxPages(Math.ceil(response.data.data.total_count / response.data.data.items.length));
      }
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  };

  const handleViewHelp = async (id) => {
    navigate(id ? `/bmr/faq/detail/${id}` : "/bmr/faq/create", {
      state: { prefilled: "show" },
    });
    if (id) dispatch(viewDetailFaq(id));
  };

  const handleDelete = async () => {
    await dispatch(deleteFaQ({ payload: { id: rowID, proc_ID: process.id } }));
    await fetchUsers({
      params: {
        id: process.id,
        status: -1,
        page: 1,
        per_page: 10,
        search: "",
      },
    });
    setOpen(false);
    setRowID(null);
  };

  const handleBackNav = () => {
    navigate('/bmr/faq');
  };

  const columns = [
    {
      id: "title",
      align: "left",
      name: "Title",
      selector: (row) => row.title,
      sortable: false,
    },
    {
      id: "type",
      name: "Status",
      align: "left",
      selector: (row) => (
        <Chip label={row.status ? "Active" : "In-Active"} color={row.status ? "success" : "error"} />
      ),
      sortable: false,
    },
    {
      name: "Action",
      align: "right",
      selector: (row) => (
        <Box key={row.id}>
          <Tooltip title="Edit">
            <span>
              <IconButton onClick={() => handleViewHelp(row.id)}>
                <EditIconButton bgColor="#C3C3C3" />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Delete">
            <span>
              <IconButton
                onClick={() => {
                  setRowID(row.id);
                  setOpen(true);
                }}
              >
                <DeleteIconButton bgColor="#FA5151" />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      ),
    },
  ];

const handleUpdateModalOpen=()=>{
  if(selectProcess.length> 0){
    setUpdateSequence(true)
  }else{
  notify.error("No Data to Display");
  }
}

  // Remove loadMoreData since child handles its own pagination
  useEffect(() => {
    if (page === 1 || updateSequence) return;

    // const fetchPageData = async () => {
      try {
        const response =  dispatch(
          listingByProcessId({
            params: {
              id: process.id,
              status: -1,
              page: page,
              per_page: 10,
              search: "",
            },
          })
        ).unwrap();

        setSelectProcess((prev) => [...prev, ...response.data.items]);
      } catch (err) {
        console.error("Failed to load more:", err);
      }
  }, [page]);

  return (
    <div className="!p-6">
      <button className="cursor-pointer mr-1 sm:mr-3 flex gap-2" onClick={handleBackNav}>
        <BackNavIcon /> Back
      </button>
      <Box className="mt-3 pt-3 bg-white flex flex-col rounded-2xl p-2"> 
        <Box display="flex" gap={2} p={2}>
          <Box className="flex">
            <p className="text-secondary text-lg">Process: {" "} </p>
            <p className="text-lg font-bold ml-1">{" "}{process?.name}</p>
          </Box>
          <Box borderLeft="2px solid #828282" className="flex" pl={2}>
            <p className="text-lg text-secondary">Module:</p>
            <p className="text-lg pr-2 font-bold ml-1">{" "}{module?.name}</p>
          </Box>
        </Box>
        <Datatable
          columns={columns}
          data={data.items ?? []}
          title="Frequently Asked Questions"
          searchPlaceholder="Search by Title"
          remote={true}
          onServerSideChange={updateFilter}
          BtnComponent={
            <Box>
              <Button className="ml-2" onClick={() => handleViewHelp()}>
                Add New FAQ
              </Button>
              <Button className="ml-2" onClick={handleUpdateModalOpen}>
                Update Sequence
              </Button>
            </Box>
          }
        />
        <DeleteModal
          open={open}
          setClose={setOpen}
          title="Are you sure you want to Delete?"
          buttonText="Delete"
          handleSuccess={handleDelete}
        />
        {updateSequence && (
          <UpdateHelpSequence
            open={updateSequence}
            setOpen={setUpdateSequence}
            page={page}
            maxPages={maxPages}
            total={total}
            selectProcess={selectProcess}
          />
        )}
      </Box>
    </div>
  );
};

export default ViewProcessingAccordian;